module.exports = __webpack_public_path__ + "static/dots-b38966a4b53316f9776fba8058eb1d9b.svg";